module.exports = __webpack_public_path__ + "media/audio18.7e4dfa5d.mp3";